import React, { useState, useEffect } from "react";
import {
  Grid,
  Switch,
  Typography,
  Button,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import "../../../components/pages/dashboard/style/style.css";
import { SpinnerRoundFilled } from "spinners-react";
import {
  createMfaSetting,
  getmfaSetting,
  updateMfaSetting,
} from "./actions/administration";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../common/components/Helper/Utils";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  gridItemTwo: {
    display: "flex",
    alignItems: "center",
  },
  gridItemThree: {
    display: "flex",
    alignItems: "center",
    marginLeft: "1.5%",
  },
}));
const MfaSettings = () => {
  const classes = useStyles();
  const [isEditMode, setIsEditMode] = useState(false);
  const [loader, setloader] = useState(true);
  const [settingId, setSettingId] = useState(null);
  const [settingsView, setSettingsView] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [userInfo, setUserInfo] = useState({
    email: "",
    phone: "",
    countryCode: "",
  });
  const [enableFeature, setEnableFeature] = useState({
    mfaEnabled: false,
    verificationType: "",
  });
  const [originalData, setOriginalData] = useState({
    mfaEnabled: false,
    verificationType: "",
  });
  const isPhoneAvailable = userInfo?.phone && userInfo?.countryCode;
  const getUserDetails = () => {
    const userDetails = sessionStorage.getItem("userDetails")
      ? JSON.parse(sessionStorage.getItem("userDetails"))
      : {};

    const user = userDetails?.user || {};

    return {
      email: userDetails?.email || user?.email || "",

      phone: userDetails?.phone || user?.phone || "",

      countryCode: userDetails?.countryCode || user?.countryCode || "",
    };
  };
  const handleOnEdit = () => {
    setIsEditMode(true);
  };
  const getUserId = () => {
    const userDetails = sessionStorage.getItem("userDetails")
      ? JSON.parse(sessionStorage.getItem("userDetails"))
      : null;

    return (
      userDetails?.userid || userDetails?.user?.userid || userDetails?.userId
    );
  };

  const fetchMfaSettings = (userid) => {
    setloader(true);

    getmfaSetting(userid, (err, res) => {
      setloader(false);

      if (err) {
        showErrorToast("Failed to fetch MFA settings");
        return;
      }

      if (res?.status === 1 && res?.data) {
        const data = res.data;

        const formattedData = {
          mfaEnabled: data.is_mfa_enabled,
          verificationType: data.is_mfa_enabled
            ? data.mfa_channel || "email"
            : "",
        };

        setEnableFeature(formattedData);
        setOriginalData(formattedData);
        setSettingId(data.userid);
      } else {
        setSettingId(null);
      }
    });
  };

  const submitData = (res) => {
    const userid = getUserId();

    if (!userid) {
      showErrorToast("User ID missing");
      return;
    }
    if (enableFeature.mfaEnabled && !enableFeature.verificationType) {
      setError("Please select a verification method");
      return;
    } else {
      setError("");
    }
    const payload = {
      userid,
      accountid: sessionStorage.getItem("accountId"),
      is_mfa_enabled: enableFeature.mfaEnabled,
      mfa_enabled_status: enableFeature.mfaEnabled ? "enabled" : null,
      mfa_channel: enableFeature.verificationType,
      is_remindme_later: false,
      remindme_date: null,
      userId: userid,
    };
    setSettingsView(true);

    const callback = (err, res) => {
      setSettingsView(false);

      if (res?.status === 1) {
        setSuccessMessage(
          "MFA settings updated successfully. Please log out and log in again to enable MFA.",
        );
        setIsEditMode(false);
        setOriginalData(enableFeature);
      } else {
        setError(res?.message || "Update Failed");
      }
    };

    if (!settingId) {
      createMfaSetting(payload, (err, res) => {
        setSettingsView(false);

        if (res?.status === 1) {
          showSuccessToast("Created Successfully");
          setIsEditMode(false);
          setSettingId(userid);
          setOriginalData(enableFeature);
        } else {
          showErrorToast("Create Failed");
        }
      });
    } else {
      updateMfaSetting(payload, (err, res) => {
        setSettingsView(false);

        if (res?.status === 1) {
          showSuccessToast("Updated Successfully");
          setIsEditMode(false);
          fetchMfaSettings(userid);
          setOriginalData(enableFeature);
        } else {
          showErrorToast(res?.message || "Update Failed");
        }
      });
    }
  };

  useEffect(() => {
    const userid = getUserId();
    const user = getUserDetails();

    setUserInfo(user);

    if (!userid) return;

    fetchMfaSettings(userid);
  }, []);

  if (loader) {
    return (
      <div className="d-spinner">
        <SpinnerRoundFilled
          size={51}
          thickness={125}
          speed={80}
          color="rgba(57, 107, 172, 1)"
          className="spp"
          mfaEnabled={loader}
        />
      </div>
    );
  }
  return (
    <Grid item xs={12} md={6}>
      <div style={{ marginTop: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container justifyContent="flex-end">
              {!isEditMode && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOnEdit}
                  className="primary-bg color-white text-center1 form-width-20"
                >
                  EDIT
                </Button>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="h6"
              component="p"
              className="primary-text uppercase"
            >
              Multi-Factor Authentication (MFA)
            </Typography>
          </Grid>
          {/* <Grid item xs={6} md={5} className={classes.gridItemTwo}> */}
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            className={classes.gridItemTwo}
          >
            <Grid item>
              <b>
                <p style={{ fontSize: "15px" }}>MFA Status</p>
              </b>
            </Grid>
            <Grid item xs={6}>
              <Switch
                checked={enableFeature.mfaEnabled}
                disabled={!isEditMode}
                onChange={(e) =>
                  setEnableFeature({
                    ...enableFeature,
                    mfaEnabled: e.target.checked,
                    verificationType: e.target.checked
                      ? enableFeature.verificationType || "email"
                      : "",
                  })
                }
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {enableFeature.mfaEnabled && (
              <RadioGroup
                value={enableFeature.verificationType}
                onChange={(e) => {
                  const value = e.target.value;
                  setEnableFeature({
                    ...enableFeature,
                    verificationType: value,
                  });
                  setError("");
                }}
              >
                <div
                  className={`mfa-card ${
                    enableFeature.verificationType === "email" ? "active" : ""
                  }`}
                  onClick={() =>
                    isEditMode &&
                    setEnableFeature({
                      ...enableFeature,
                      verificationType: "email",
                    })
                  }
                >
                  <div className="mfa-left">
                    <div>
                      <b>
                        <p style={{ fontSize: "15px", margin: 0 }}>
                          Email Verification
                        </p>
                      </b>
                      <p style={{ fontSize: "13px", color: "#777", margin: 1 }}>
                        {userInfo?.email || "-"}
                      </p>
                    </div>
                  </div>

                  <Radio
                    value="email"
                    checked={enableFeature.verificationType === "email"}
                    disabled={!isEditMode}
                    style={{ color: "#383838" }}
                  />
                </div>

                <div
                  className={`mfa-card ${
                    enableFeature.verificationType === "phone" ? "active" : ""
                  } ${!isPhoneAvailable ? "disabled-card" : ""}`}
                  onClick={() => {
                    if (!isEditMode || !isPhoneAvailable) return;

                    setEnableFeature({
                      ...enableFeature,
                      verificationType: "phone",
                    });
                  }}
                >
                  <div className="mfa-left">
                    <div>
                      <b>
                        <p style={{ fontSize: "15px", margin: 0 }}>
                          Phone Verification
                        </p>
                      </b>
                      <p style={{ fontSize: "13px", color: "#777", margin: 1 }}>
                        {isPhoneAvailable ? (
                          `${userInfo.countryCode} ${userInfo.phone}`
                        ) : (
                          <span
                            style={{
                              color: "#d32f2f",
                              fontWeight: 500,
                              fontStyle: "italic",
                            }}
                          >
                            Phone Number is not available
                          </span>
                        )}
                      </p>
                    </div>
                  </div>

                  <Radio
                    value="phone"
                    checked={enableFeature.verificationType === "phone"}
                    disabled={!isEditMode || !isPhoneAvailable}
                    style={{ color: "#383838" }}
                  />
                </div>
              </RadioGroup>
            )}
            <Grid item xs={12}>
              {error && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "8px" }}>
                  {error}
                </p>
              )}

              {successMessage && (
                <p
                  style={{ color: "green", fontSize: "13px", marginTop: "8px" }}
                >
                  {successMessage}
                </p>
              )}
            </Grid>
          </Grid>
          {isEditMode && (
            <>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsEditMode(false);
                    setEnableFeature(originalData);
                    setError("");
                    setSuccessMessage("");
                  }}
                  className="primary-bg color-white text-center1 form-width-20"
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={submitData}
                  className="primary-bg color-white text-center1 form-width-20"
                  disabled={settingsView}
                  endIcon={
                    settingsView ? (
                      <CircularProgress
                        style={{ width: 22, height: 22, color: "#fff" }}
                      />
                    ) : null
                  }
                >
                  Update
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    </Grid>
  );
};

export default MfaSettings;
